export default "__VITE_ASSET__09d34575__"